import { useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import {
  errorNotification,
  successNotification,
} from "../../../../../../common/variables/notification";

interface LiveViewRecordingsVideoListHeaderProps {
  title?: string;
  refetch: () => Promise<unknown>;
  onRefresh?: () => void;
}

const LiveViewRecordingsVideoListHeader = ({
  title = "Recording Video List",
  refetch,
  onRefresh,
}: LiveViewRecordingsVideoListHeaderProps): JSX.Element => {
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async (): Promise<void> => {
    try {
      setRefreshing(true);

      if (onRefresh) onRefresh();

      await refetch();

      successNotification("Recording list refreshed");
    } catch (err) {
      console.error("Failed to refresh recording list", err);

      errorNotification("Failed to refresh recording list");
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.5em 1em",
        backgroundColor: theme => theme.palette.otherBackground.main,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 500, color: theme => theme.palette.text.secondary }}
      >
        {title}
      </Typography>

      <IconButton
        aria-label="refresh"
        size="small"
        onClick={handleRefresh}
        disabled={refreshing}
        sx={{
          border: theme => `1px solid ${theme.palette.text.secondary}`,
          borderRadius: "8px",
          width: 36,
          height: 36,
        }}
      >
        {refreshing ? (
          <CircularProgress size={16} />
        ) : (
          <CachedOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
};

export default LiveViewRecordingsVideoListHeader;
